export default {
  MapElemInfoNone: require('./MapElemInfoNone').default,
  MapElemInfoNew: require('./MapElemInfoNew').default,
  MapElemInfoComment: require('./MapElemInfoComment').default,
  MapElemInfoCommentContainer: require('./MapElemInfoCommentContainer').default,
};
